import { render, staticRenderFns } from "./RevenueManagerSetupRatesActivation.vue?vue&type=template&id=694a239e&scoped=true&"
import script from "./RevenueManagerSetupRatesActivation.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupRatesActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a239e",
  null
  
)

export default component.exports